const url = "https://app.formax.cloud/user/";
//const url = "http://192.168.0.104:5001/user/";

exports.baseUrl = url;
